<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
        d="M32,30.31,21.33,19.64a12,12,0,1,0-1.49,1.55L30.48,31.83ZM12,22a9.84,9.84,0,1,1,9.84-9.83A9.84,9.84,0,0,1,12,22Z" />
</svg>